import Vue from 'vue'
import VueRouter from 'vue-router'
import * as routeNames from './route-names'
import * as Sentry from '@sentry/browser'
import store from '@/store'
import {SET_WEBSOCKET_AUTH} from '@/store/modules/websocket/mutation-types'

const Wallboard = () => import(/* webpackChunkName: "contact-centre-wallboard-wrapper" */ '@/views/Wallboard.vue')
const BaseNotFound = () => import(/* webpackChunkName: "contact-centre-wallboard-wrapper" */ '@windsor-telecom/customer-portal-framework/src/components/BaseNotFound')

Vue.use(VueRouter)

const routes = [
    {
        path: '/:wallboardUuid?/:token?',
        name: routeNames.WALLBOARD,
        component: Wallboard,
        props: true,
        // Handle auth before route is rendered
        beforeEnter: async (to, from, next) => {
            const {wallboardUuid, token} = to.params
            let auth = null

            try {
                if (wallboardUuid && token) {
                    auth = window.btoa(`${wallboardUuid}:${token}`)
                }

                await store.dispatch('auth/me')
            } catch (e) {
                if (e.status !== 401) {
                    Sentry.withScope(scope => {
                        scope.setExtra('context', e)
                        Sentry.captureMessage('Error in /me request')
                    })
                }
            } finally {
                store.commit(`websocket/${SET_WEBSOCKET_AUTH}`, auth)
                next()
            }
        }
    },
    {
        path: '*',
        component: BaseNotFound
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
